import { Pipe, PipeTransform } from '@angular/core';
import { first, some as _some, get as _get, omit as _omit} from 'lodash-es';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TemplateService } from 'src/app/templates/services/template.service';
import { checkSome } from 'src/app/shared/helpers/helpers';

@Pipe({
  name: 'enableTemplateFeature'
})
export class EnableTemplateFeaturePipe implements PipeTransform {
  constructor(private templateService: TemplateService) {}
  transform(value: any, ...args: unknown[]): unknown {
    let { templateFeatureFlags } = value;
    templateFeatureFlags = _omit(templateFeatureFlags, 'user');
    return checkSome(templateFeatureFlags, 'Yes');
  }

}
